module.exports = __webpack_public_path__ + "img/home.83a747e7.svg";